import * as React from "react";
import {Fragment} from "react";
import DatePicker from "./DatePicker";
import {Col, Row} from "reactstrap";

export default class DatePickerWithLabel extends React.Component{

  render() {

    return <Fragment>
      &nbsp;
      <Row>
        <Col>
          <b>{this.props.label || ""}</b>
          <DatePicker
            onChange={(dateValue) => this.props.onChange(dateValue)}
            value={this.props.value}
            placeholder={this.props.placeHolder || ""}
          />
        </Col>
      </Row>
    </Fragment>
  }
}
